@if (isInitialized) {
  <oe-flat-widget button [link]="'/device/' + edge.id + newNavigationUrlSegment + '/history/gridchart'"
    [icon]="{name: 'oe-grid', color:'dark'}" [title]="'GENERAL.GRID' | translate">
    @if (offGridTime > 0) {
      <oe-flat-widget-line [name]="'GRID_STATES.OFF_GRID' | translate"
        channelAddress="_sum/GridModeOffGridTime" [converter]="TIME_CONVERTER">
      </oe-flat-widget-line>
    }
    @if (restrictionTime14a > 0) {
      <oe-flat-widget-line [name]="'GRID_STATES.CONSUMPTION_LIMITATION' | translate"
        channelAddress="ctrlEssLimiter14a0/CumulatedRestrictionTime" [converter]="TIME_CONVERTER">
      </oe-flat-widget-line>
    }
    @if (restrictionTimeRcr > 0) {
      <oe-flat-widget-line [name]="'GRID_STATES.FEED_IN_LIMITATION' | translate"
        channelAddress="ctrlEssRippleControlReceiver0/CumulatedRestrictionTime" [converter]="TIME_CONVERTER">
      </oe-flat-widget-line>
    }
    @if (restrictionTimeRcr > 0 || offGridTime > 0 || restrictionTime14a > 0) {
      <oe-flat-widget-horizontal-line></oe-flat-widget-horizontal-line>
    }
    @if (hasGridMeter) {
      <oe-flat-widget-line [name]="'GENERAL.GRID_SELL_ADVANCED' | translate" channelAddress="_sum/GridSellActiveEnergy"
        [converter]="Utils.CONVERT_TO_KILO_WATTHOURS">
      </oe-flat-widget-line>
      <oe-flat-widget-line [name]="'GENERAL.GRID_BUY_ADVANCED'| translate" channelAddress="_sum/GridBuyActiveEnergy"
        [converter]="Utils.CONVERT_TO_KILO_WATTHOURS">
      </oe-flat-widget-line>
    }
  </oe-flat-widget>
}